import { render, staticRenderFns } from "./testate.vue?vue&type=template&id=18c17fc6"
import script from "./testate.vue?vue&type=script&lang=js"
export * from "./testate.vue?vue&type=script&lang=js"
import style0 from "./testate.vue?vue&type=style&index=0&id=18c17fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports